import { ISignInRequestDto, IUser } from '../types';
import { AxiosResponse } from 'axios';
import settings from '../settings';
import api from './base';

export function auth(credential: ISignInRequestDto): Promise<AxiosResponse<IUser>> {
  const uri = `${settings.getApiURI()}/auth/v1/sign-in-admin`;

  return api.http.post(uri, credential);
}
